//include 28
jQuery(function(){
    
    var dataPrependString = "bookmarkProperty";

    var checkBookmarks = function () {
        $("[data-bookmark]").each(function () {
            var $this = $(this);
            var id = $this.data("bookmark-id");
            if (!!id) {
                if (window.pixelpoint.merkliste.exists(id)) {
                    $this.addClass("bookmark-added");
                }
                else {
                    $this.removeClass("bookmark-added");
                }
            }
        });
    }

    $("body").on("click", "[data-bookmark]", function () {
        var $this = $(this);
        var data = $this.data("bookmark-contents");
        var id = $this.data("bookmark-id");

        if (window.pixelpoint.merkliste.exists(id)) {
            window.pixelpoint.merkliste.remove(id);
            $this.removeClass("bookmark-added");
            checkBookmarks();
            return;
        }

        var item = {};
        if (!data) {
            var storedData = $this.data();
            var itemData = {};
            for (var key in storedData) {
                if (storedData.hasOwnProperty(key)) { //important, so we do not access the prototype. Do not access the prototype here or bad thinks will happen!

                    if (key.indexOf(dataPrependString) == 0) {
                        var propertyName = key.replace(dataPrependString, "");
                        if (!!propertyName) {
                            propertyName = propertyName.charAt(0).toLowerCase() + propertyName.slice(1);
                            itemData[propertyName] = storedData[key];
                        }
                    }

                }
            }
            data = itemData;
        }
        window.pixelpoint.merkliste.addOrUpdate(data, id);
        $this.addClass("bookmark-added");

        //***************tag manager*********************************
        if (!!data.title) {
            var tagData = {};
            tagData.Starname = data.title;
            window.pixelpoint.tagManager.event("icon_star_merken", tagData);
        }        
        //***********************************************************

        checkBookmarks();
    });

    window.pixelpoint.pubSub.subscribe(window.pixelpoint.pubSub.events.checkBookmarks, checkBookmarks);
    checkBookmarks();

});